import {
  GET_CRS_CUSTOMER_LIST_DATA,
  GET_CRS_CUSTOMER_LIST_DATA_SUCCESS,
  GET_CRS_CUSTOMER_LIST_DATA_FAIL,
  GET_CRS_SEGMENT_LIST_DATA,
  GET_CRS_SEGMENT_LIST_DATA_SUCCESS,
  GET_CRS_SEGMENT_LIST_DATA_FAIL,
  GET_CRS_CLUSTER_LIST_DATA,
  GET_CRS_CLUSTER_LIST_DATA_SUCCESS,
  GET_CRS_CLUSTER_LIST_DATA_FAIL,
  GET_CRS_CUSTOMER_TYPE_LIST_DATA,
  GET_CRS_CUSTOMER_TYPE_LIST_DATA_SUCCESS,
  GET_CRS_CUSTOMER_TYPE_LIST_DATA_FAIL,
  GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA,
  GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA_SUCCESS,
  GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA_FAIL
} from '../../actions/crs/crsListView';

export const initialState = {
  customerList: { isLoading: false, data: {}, error: null },
  segmentList: { isLoading: false, data: [], error: null },
  clusterList: { isLoading: false, data: [], error: null },
  customerTypeList: { isLoading: false, data: [], error: null },
  riskLevelChangeList: { isLoading: false, data: [], error: null }
};

function crsListView(state = initialState, action) {
  switch (action.type) {
    // Customer List
    case GET_CRS_CUSTOMER_LIST_DATA:
      return {
        ...state,
        customerList: { isLoading: true, data: {}, error: null }
      };
    case GET_CRS_CUSTOMER_LIST_DATA_SUCCESS:
      return {
        ...state,
        customerList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_CUSTOMER_LIST_DATA_FAIL:
      return {
        ...state,
        customerList: { isLoading: false, data: null, error: action.payload }
      };

    // Segment list

    case GET_CRS_SEGMENT_LIST_DATA:
      return {
        ...state,
        segmentList: {
          isLoading: true,
          data: [{ id: '-', name: 'Loading segments...' }],
          error: null
        }
      };
    case GET_CRS_SEGMENT_LIST_DATA_SUCCESS:
      return {
        ...state,
        segmentList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_SEGMENT_LIST_DATA_FAIL:
      return {
        ...state,
        segmentList: { isLoading: false, data: null, error: action.payload }
      };

    // Cluster list

    case GET_CRS_CLUSTER_LIST_DATA:
      return {
        ...state,
        clusterList: {
          isLoading: true,
          data: [{ id: '-', name: 'Loading clusters...' }],
          error: null
        }
      };
    case GET_CRS_CLUSTER_LIST_DATA_SUCCESS:
      return {
        ...state,
        clusterList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_CLUSTER_LIST_DATA_FAIL:
      return {
        ...state,
        clusterList: { isLoading: false, data: null, error: action.payload }
      };

    // Customer Type list

    case GET_CRS_CUSTOMER_TYPE_LIST_DATA:
      return {
        ...state,
        customerTypeList: {
          isLoading: true,
          data: [{ id: '-', name: 'Loading customer types...' }],
          error: null
        }
      };
    case GET_CRS_CUSTOMER_TYPE_LIST_DATA_SUCCESS:
      return {
        ...state,
        customerTypeList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_CUSTOMER_TYPE_LIST_DATA_FAIL:
      return {
        ...state,
        customerTypeList: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    // Risk Level Change list

    case GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA:
      return {
        ...state,
        riskLevelChangeList: {
          isLoading: true,
          data: [{ id: '-', name: 'Loading risk level changes...' }],
          error: null
        }
      };
    case GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA_SUCCESS:
      return {
        ...state,
        riskLevelChangeList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA_FAIL:
      return {
        ...state,
        riskLevelChangeList: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    default:
      return {
        ...state
      };
  }
}

export default crsListView;
